import { useEffect, useRef, useState, useCallback } from 'react';
import { stateList } from '~/util/stateList';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { getCitiesByUf } from '~/util/ibge';

export const useAddressForm = (formRef, initialAddress = {}) => {
  const [searchedCEP, setSearchedCEP] = useState('');
  const [cityList, setCityList] = useState([]);
  const [noNumber, setNoNumber] = useState(false);
  const [addressNumber, setAddressNumber] = useState('');
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const toastId = useRef(null);

  const searchCEP = async cep => {
    if (searchedCEP === cep) return;
    setSearchedCEP(cep);

    try {
      toastId.current = toast.info(`Buscando por CEP: ${cep}...`, {
        autoClose: false,
      });
      const { data } = await api.get(`cep/${cep}`);

      const formData = formRef.current.getData();
      formRef.current.setData({
        ...formData,
        address: { ...data },
      });

      const state = stateList.find(s => s.value === data.state);
      setSelectedState(state);
      setSelectedCity({ label: data.city, value: data.city });

      toast.dismiss(toastId.current);
    } catch (err) {
      toast.update(toastId.current, {
        render: 'Endereço não encontrado!',
        type: toast.TYPE.ERROR,
        autoClose: 5000,
      });
    }
  };

  const initializeAddress = useCallback(async () => {
    if (initialAddress) {
      if (initialAddress.state) {
        const state = stateList.find(s => s.value === initialAddress.state);
        if (state) setSelectedState(state);
      }

      if (initialAddress.number === 'sn') {
        setNoNumber(true);
        setAddressNumber('');
      } else if (initialAddress.number) {
        setNoNumber(false);
        setAddressNumber(initialAddress.number);
      }

      if (initialAddress.state && initialAddress.city) {
        try {
          const { data } = await api.get(
            `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${initialAddress.state}/municipios`
          );

          const parsedCities = data.map(city => ({
            value: city.nome,
            label: city.nome,
          }));

          setCityList(parsedCities);

          const citySelected = parsedCities.find(
            city => city.value === initialAddress.city
          );
          if (citySelected) {
            setSelectedCity(citySelected);
          }
        } catch (err) {
          console.error('Erro ao carregar cidades:', err);
        }
      }
    }
  }, [initialAddress]);

  useEffect(() => {
    initializeAddress();
  }, [initializeAddress]);

  useEffect(() => {
    const getCities = async () => {
      setCityList(await getCitiesByUf(selectedState));
    };

    getCities();
  }, [selectedState]);

  return {
    searchCEP,
    cityList,
    noNumber,
    setNoNumber,
    addressNumber,
    setAddressNumber,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
    initializeAddress,
  };
};
